import { createApp } from 'vue'
import { Notify, Quasar } from 'quasar'
import { NotifyInit } from './boot/Notify'
import LayoutBase from 'layouts/LayoutBase.vue'
import router from './router/router'

NotifyInit()

const context = {
  ...window.context,
}
const app = createApp(LayoutBase)

app.provide('context', context)
app.config.globalProperties.$console = console.log

app.use(router)
app.use(Quasar, {
  plugins: {
    Notify,
  },
  config: {
    notify: {},
    screen: {
      bodyClasses: true,
    },
  },
})

app.mount('#app')
